import React, { Component } from "react";
import {
  Card,
  Row,
  Col,
  Button,
  Input,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "reactstrap";
import LessonCard from "../LessonCard";
import DeleteButton from "../AuthorUIComponents/DeleteButton";
import {
  sortableHandle,
  sortableContainer,
  sortableElement
} from "react-sortable-hoc";
import Filter from "../Filter";
import arrayMove from "array-move";

const handleSortStart = ({ node }) => {
  const tr = document.getElementById("drag-row-deck").getElementsByTagName("tr");
  const containerWidth = document.getElementsByClassName(
    "items-bank-left-container"
  )[0].offsetWidth;
  let { width } = tr[0].getBoundingClientRect();
  tr[0].style.clip = `rect(0px, ${containerWidth}px, 55px, 0px)`;
};

const DragHandle = sortableHandle(() => <span className="drag-handle" />);
const SortableItem = sortableElement(
  ({
    value,
    index,
    lastItem,
    reArrange,
    onSortEnd,
    handlePreview,
    handleDelete,
    editDeckLogic
  }) => {
    return (
      <React.Fragment>
        {value.type === "DeckLogic" ? (
          <tr>
            <td className="directive-row" colSpan="12">
              my Deck Logic [5 Directives]
            </td>
          </tr>
        ) : (
          <tr>
            {reArrange && (
              <td>
                <DragHandle />
                <Input
                  className="item-input"
                  onChange={this.handleOrderChange}
                  value={value.index}
                />
                <span className="lesson-arrange-arrows arrange-arrows">
                  {index > 0 && (
                    <span
                      onClick={() =>
                        onSortEnd({
                          oldIndex: index,
                          newIndex: Number(index) - 1
                        })
                      }
                      className="lesson-arrange-arrow-up"
                    />
                  )}
                  {Number(index) !== Number(lastItem) - 1 && (
                    <span
                      onClick={() =>
                        onSortEnd({
                          oldIndex: index,
                          newIndex: Number(index) + 1
                        })
                      }
                      className="lesson-arrange-arrow-down"
                    />
                  )}
                </span>
                <DeleteButton
                  handleDelete={handleDelete}
                  index={index}
                  item={value}
                />
              </td>
            )}

            <td>{value.code}</td>
            <td>{value.name}</td>
            <td>{value.type}</td>
            <td>{value.nodes}</td>
            <td>{value.tags}</td>
            <td>{value.card}</td>
          </tr>
        )}
        {!reArrange &&
          (value.type === "DeckLogic" ? (
            <div id={`row-side-menu-${index}`} className="row-side-menu">
              <Button onClick={editDeckLogic} className="icon-btn-edit">
                <i className="edit-deck-logic-icon" />
              </Button>
            </div>
          ) : (
            <div id={`row-side-menu-${index}`} className="row-side-menu">
              <Button onClick={() => handlePreview(value)} className="icon-btn">
                <i className="screen-eye-icon" />
              </Button>
              <Button onClick={() => handlePreview(value)} className="icon-btn">
                <i className="preview-icon" />
              </Button>
            </div>
          ))}
      </React.Fragment>
    );
  }
);
const SortableContainer = sortableContainer(({ children }) => {
  return <tbody>{children}</tbody>;
});

export default class LessonDeckBank extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "",
      reArrangeActive: false,
      addDeckMenu: false,
      createDeckLogicMenu: false,
      previewItem: false,
      simulateItem: false,
      lessonDecks: [
        {
          index: 1,
          code: "deck-code",
          name: "Abra Deck",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 2,
          code: "deck-code",
          name: "Shaheen",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 3,
          code: "deck-code",
          name: "Bravo",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 4,
          code: "deck-code",
          name: "Mystethic",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 5,
          code: "deck-code",
          name: "React Deck",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 6,
          code: "deck-code",
          name: "Abra Deck Junior",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 7,
          code: "deck-code",
          name: "Shaheen Cena",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 8,
          code: "deck-code",
          name: "Bravo WW",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 9,
          code: "deck-code",
          name: "Mystethic View",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 9,
          code: "deck-code",
          name: "Mystethic View",
          type: "DeckLogic",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        },
        {
          index: 10,
          code: "deck-code",
          name: "AngularReact Deck",
          type: "Deck",
          nodes: "Writers Goal",
          tags: "get-em-tiger",
          card: "20"
        }
      ],
      itemTableData: [],
      addItemCardData: [],
      singleItem: null
    };
    this.handleDeckLogicMenu = this.handleDeckLogicMenu.bind(this);
    this.handleAddDeckMenu = this.handleAddDeckMenu.bind(this);
    this.updateLessonDeckBank = this.updateLessonDeckBank.bind(this);
    this.addToDeckBank = this.addToDeckBank.bind(this);
  }

  componentDidMount() {
    this.setState({
      itemTableData: this.state.lessonDecks,
      addItemCardData: this.state.lessonDecks
    });
  }

  handleAddDeckMenu = () => {
    this.setState({
      addDeckMenu: !this.state.addDeckMenu
    });
  };
  updateLessonDeckBank = () => {
    console.log("updated lesson decks");
  };

  handleDeckLogicMenu = () => {
    this.setState({
      createDeckLogicMenu: !this.state.createDeckLogicMenu
    });
  };
  addToDeckBank = () => {
    console.log("Added to deck bank");
  };

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ itemTableData }) => ({
      itemTableData: arrayMove(itemTableData, oldIndex, newIndex)
    }));
  };
  rearrangeToggle = () => {
    this.setState({
      reArrangeActive: !this.state.reArrangeActive
    });
  };
  deleteRow = item => {
    const { itemTableData } = this.state;
    this.setState({
      itemTableData: itemTableData.filter(val => val.itemCode !== item.itemCode)
    });
  };
  handlePreview = value => {
    let showPreviewModalChanges = {
      selectedDeck: value,
      showPreviewModal: true
    };
    this.setState({
      ...showPreviewModalChanges
    });
  };
  showSideIcons = show => {
    if (show) {
      this.setState({ sideIcons: true });
    } else {
      this.setState({ sideIcons: false });
    }
  };
  itemsFilter = (e, type) => {
    const { dummyData } = this.state;

    e.target.value !== ""
      ? this.setState({
          [type]: dummyData.filter(
            val =>
              val.itemCode
                .toLowerCase()
                .search(e.target.value.toLowerCase()) !== -1
          )
        })
      : this.setState({
          [type]: dummyData
        });
  };

  tableScrollHandle = e => {
    [...document.getElementsByClassName("row-side-menu")].map(
      ele =>
        (ele.style.transform = `translate(0px, -${e.target.scrollTop + 50}px)`)
    );
  };
  onChg = ({ target }) => this.setState({ [target.name]: target.value });

  render() {
    const {
      reArrangeActive,
      itemTableData
    } = this.state;
    const filterRule = st =>
      st.name.toLowerCase().indexOf(this.state.filter.toLowerCase()) > -1;
    const filteredDecks = this.state.itemTableData.filter(filterRule);

    const previewModel = show => (
      <Modal isOpen={show}>
        <ModalHeader>{this.state.selectedDeck.name}</ModalHeader>
        <ModalBody>
          <div>
            <label>Name: </label>
            {this.state.selectedDeck.name}
            <span />
          </div>
          <div>
            <label>Type: </label>
            {this.state.selectedDeck.type}
            <span />
          </div>
          <div>
            <label>Tags: </label>
            {this.state.selectedDeck.tags}
            <span />
          </div>
          <div>
            <label>Nodes: </label>
            {this.state.selectedDeck.nodes}
            <span />
          </div>
          <div>
            <label>Code: </label>
            {this.state.selectedDeck.code}
            <span />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => this.setState({ showPreviewModal: false })}
            color="secondary"
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );

    return (
      <React.Fragment>
          <LessonCard
            iconClass="deck-bank"
            heading="Deck Bank"
            isCollapsable={true}
            headerButtons={[
              <Button className="icon-btn" onClick={this.rearrangeToggle}>
                <i
                  className={`icon-rearrange-icon-white ${
                    reArrangeActive ? "rearrange-active" : ""
                  }`}
                />
              </Button>,
              <Button className="icon-btn">
                <i className="icon-preview-icon" />
              </Button>,

              <Button
                className={`add-btn ${
                  this.state.createDeckLogicMenu ? "active" : ""
                }`}
                onClick={() => this.props.createDeckLogic()}
              >
                + Create Deck Logic
              </Button>,
              <Button
                className={`add-btn ${this.state.addDeckMenu ? "active" : ""}`}
                onClick={() => this.props.addDecks()}
              >
                + Add Decks
              </Button>
            ]}
          >
            <Filter
              onChg={this.onChg}
              filter={this.state.filter}
              placeholder={"Add Text to Filter Items..."}
            />
            <div className="table-container">
              <div
                className="items-bank-left-container"
                onScroll={this.tableScrollHandle}
              >
                <Table striped hover className="items-bank-table">
                  {/* <div className='dragging-row'></div> */}
                  <div id="drag-row-deck" />
                  <thead className="card-header">
                    <tr>
                      {reArrangeActive && <th>Rearrange Actions</th>}
                      <th>Code</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Nodes</th>
                      <th>Tags</th>
                      <th>Cards</th>
                    </tr>
                  </thead>
                  <SortableContainer
                    onSortStart={handleSortStart}
                    helperContainer={document.getElementById("drag-row-deck")}
                    lockToContainerEdges
                    useDragHandle
                    lockAxis={"y"}
                    helperClass={"dragging-row"}
                    onSortEnd={this.onSortEnd}
                  >
                    {filteredDecks.map((value, index) => (
                      <SortableItem
                        reArrange={reArrangeActive}
                        key={`item-${index}`}
                        index={index}
                        lastItem={itemTableData.length}
                        value={value}
                        onSortEnd={this.onSortEnd}
                        handlePreview={this.handlePreview}
                        handleDelete={this.deleteRow}
                        editDeckLogic={() => this.props.createDeckLogic()}
                      />
                    ))}
                  </SortableContainer>
                </Table>
              </div>
            </div>
          </LessonCard>
        
       {/* <Col colSpan="6" sm="12" md="6">
          <Col colSpan="12" sm="12" md="12">
            {this.state.addDeckMenu && (
              <AddDecks
                onAdd={this.updateLessonDeckBank}
                onClose={this.handleAddDeckMenu}
                showPreview={this.handlePreview}
              />
            )}
          </Col>
          <Col colSpan="12" sm="12" md="12">
            {this.state.createDeckLogicMenu && (
              <CreateDeckLogic
                onAdd={this.addToDeckBank}
                onClose={this.handleDeckLogicMenu}
              />
            )}
          </Col>
        </Col>*/}
        {this.state.showPreviewModal &&
          previewModel(this.state.showPreviewModal)}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorLesson/LessonDeckBank.js